import React, {Component} from 'react'
import InService from '../../../../components/Operations/Transport/InService/InService'
import {compose} from 'recompose'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import withSpinning from '../../../../elements/HOC/withSpinning'
import withSort from '../../../../elements/HOC/withSort'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import {get, isEmpty, omit, pick} from 'lodash'
import {message, Select} from 'antd'
import Orders from '../../../../api/Sales/Orders'

class InServiceCont extends Component {
  state = {
    vehicles: [],
    ContractsSelectCmp: Select,
  }

  formRef = React.createRef()
  bookingFormRef = React.createRef()

  api = new Orders()

  fetchVehicles = async contractID => {
    // if (!isEmpty(contractID)) {
    try {
      this.setState({fetchingVehicles: true})
      const vehicles = await this.api.lines.listActive(
        contractID || this.state.contract,
      )
      this.setState({vehicles, fetchingVehicles: false})
    } catch (e) {
      this.setState({fetchingVehicles: false})
      message.error(e.errorMessage)
    }
    // }
  }
  onChangeCompany = company => {
    const url = `products/categories` + `?owner=${company}` + '&select=*'
    this.url = url
    const CategorySelect = compose(
      withUrlFetch({
        name: 'products_categories',
        url: url,
        cache: true,
        forceFetch: true,
      }),
      withSpinning,
      withSort,
    )(CustomSelect)
    this.formRef.current &&
      this.formRef.current.resetFields(['client._id', 'contract._id'])
    this.setState({company, CategorySelect})
  }
  onChangeClient = client => {
    this.formRef.current && this.formRef.current.resetFields(['contract._id'])
    if (!isEmpty(client)) {
      const owner = client.replace('partners/', '')
      const {company} = this.state
      const url =
        `clients/` +
        (isEmpty(owner) ? '' : `${owner}`) +
        `/contracts?company=${company}&state=active`
      const ContractsSelectCmp = compose(
        withUrlFetch({
          name: 'clients_contracts',
          url: url,
          cache: true,
          forceFetch: true,
        }),
        withSpinning,
        withSort,
      )(CustomSelect)
      this.setState({client, ContractsSelectCmp})
    } else {
      this.setState({
        client: '',
        ContractsSelectCmp: Select,
        url: '',
      })
    }
  }
  onChangeContract = contract => {
    if (!isEmpty(contract)) {
      this.setState({
        contract,
      })
      this.fetchVehicles(contract)
    }
  }

  onShowEditBooking = async (e, booking) => {
    this.setState({
      visibleBooking: true,
      booking,
      modalType: 'edit',
    })
  }
  onCancelBooking = () => {
    this.setState({
      visibleBooking: false,
    })
  }
  onEditBooking = async () => {
    const values = await this.checkBookingForm()
    try {
      this.setState({
        updatingBooking: true,
      })
      await this.api.lines.update(
        omit(values, [
          'order',
          'contract',
          'invoiced',
          'amount',
          'type',
          'delivery',
        ]),
      )
      this.setState({
        updatingBooking: false,
      })
      this.onCancelBooking()
      await this.fetchVehicles(this.state.contractID)
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        updatingBooking: false,
      })
    }
  }
  checkBookingForm = () => {
    return new Promise((res, rej) => {
      this.bookingFormRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          res(
            Object.assign(
              {},
              pick(this.state.booking, ['_id', '_key']),
              values,
            ),
          )
        }
      })
    })
  }

  render() {
    return (
      <InService
        {...this.state}
        {...pick(this, [
          'onChangeClient',
          'onChangeCompany',
          'fetchVehicles',
          'onChangeContract',
          'bookingFormRef',
          'formRef',
          'onShowEditBooking',
          'onCancelBooking',
          'onEditBooking',
        ])}
      />
    )
  }
}

InServiceCont.propTypes = {}
InServiceCont.defaultProps = {}

export default InServiceCont
